module.exports = __webpack_public_path__ + "static/media/hair-brush.eb9b9ba8.svg";